import { Grid, withStyles } from '@material-ui/core'
import React, { useEffect } from 'react'
import { acGetCustomerInformation } from '../../../class/actions'
import { ROUTER } from '../../../class/constants'
import { useDispatch, connect } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Label } from '../../default'
import { rCNPJ, rEMAIL } from '../../../class/utils'
import { CardSearchEmailCnpj } from '../../cards'

const PanelPlanSearch = ({ classes, customerInfo }) => {

  const { t } = useTranslation()
  const dispatch = useDispatch()
  const history = useHistory()

  const onSearch = (emailCnpj) => {
    const isEmail = emailCnpj.match(rEMAIL)
    const isCnpj = emailCnpj.match(rCNPJ)

    if (!isEmail && !isCnpj) {
      return
    }

    return history.push({
      pathname: isEmail ? ROUTER.CUSTOMER_PLAN_TABLE.SEARCH_EMAIL : ROUTER.CUSTOMER_PLAN_TABLE.SEARCH_CNPJ,
      state: {
        data: emailCnpj
      }
    })
  }

  useEffect(() => {
    dispatch(acGetCustomerInformation())
      .catch(err => console.error(err))
  }, [dispatch])

  return (
    <Grid container spacing={3} className={classes.root}>
      <Grid item xs={12}>
        <Label v='h5' bold>{t('panels.plan.title')}</Label>
      </Grid>
      <Grid item xs={12}>
        <CardSearchEmailCnpj title={t('cards.planSearch.title')} caption={t('cards.planSearch.caption')} onSearch={onSearch} />
      </Grid>
    </Grid>
  )
}


const styles = theme => ({
  root: {
    display: 'flex',
    flex: 1
  }
})

const mapStateToProps = ({ ReducerCustomer }) => ({
  customerInfo: ReducerCustomer.customerInfo
})

export default connect(mapStateToProps)(withStyles(styles)(PanelPlanSearch))